import { Component } from '@angular/core';
import { MemberInsurerServiceService } from '../../services/member-insurer-service.service';
import { Roles } from '../../models/commonmodel';
import { AgentFilterState } from '../admindashboard/admindashboard.component';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from "../shared/loader/loader.component";
import { NoDataFoundComponent } from "../shared/no-data-found/no-data-found.component";
import { AdminCardComponent } from "../admin-card/admin-card.component";
import { AddAdminProviderComponent } from '../add-admin-provider/add-admin-provider.component';
import { AddAdminInsurerComponent } from '../add-admin-insurer/add-admin-insurer.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { AddAdminDistributorComponent } from '../add-admin-distributor/add-admin-distributor.component';
import { ViewModeToggleComponent } from "../shared/components/view-mode-toggle/view-mode-toggle.component";
import { AppAdminTableViewComponent } from "../app-admin-table-view/app-admin-table-view.component";
import { Router } from '@angular/router';
import { ConfirmationmodalComponent } from '../shared/components/confirmationmodal/confirmationmodal.component';
import { NotificationService } from '../shared/services/notifications.service';
import { ActivatedRoute } from '@angular/router';
import { CommonAdminComponentComponent } from '../super-admin/orgs-registration/common-admin-registration/common-admin-component.component';

@Component({
  selector: 'app-add-admins',
  standalone: true,
  imports: [MatInputModule, MatFormFieldModule, FormsModule, CommonModule, LoaderComponent, NoDataFoundComponent, AdminCardComponent, ViewModeToggleComponent, AppAdminTableViewComponent],
  templateUrl: './add-admins.component.html',
  styleUrl: './add-admins.component.scss'
})
export class AddAdminsComponent {
onroleChange($event: Event) {
console.log($event)}
  adminInsurerList: any[] = [];
  adminInsurerListTemp: any[] = [];
  adminDistributorList: any[] = [];
  adminDistributorListTemp: any[] = [];
  
  constructor(private memberService: MemberInsurerServiceService, private dialog: MatDialog,
    private restService: MemberInsurerRestService, private activatedRoute: ActivatedRoute,private notificationService : NotificationService,
    private router: Router
  ) {
  }

  statusupdateTrue(adminInfo: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '350px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    this.notificationService.showNotification(adminInfo.userId)

    const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
    dialogRef.componentInstance.title = 'Confirm';
    dialogRef.componentInstance.mode = 'Add';
    dialogRef.componentInstance.message = 'Are you sure you want to update the status?';

    dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.restService.updateAdminStatus(adminInfo.userId, true).subscribe({
          next: (response: string) => {
            this.notificationService.showNotification('Status updated sucessfully');
            if (this.selectedTab === 0)
              this.memberService.emitRefreshAdminInsurer();
            else if (this.selectedTab === 1) {
              this.memberService.emitRefreshAdminProvider();
            }
            else {
              this.memberService.emitRefreshAdminDistributor();
            }
          },
          error: (error) => {
            const message = error?.error?.message || 'An error occurred during status update.';
            this.notificationService.showNotification(message, 'error');
          }
        });
      }
    })
  }
  statusupdateFalse(adminInfo: any) {
    console.log(this.role)

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '350px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;

    const dialogRef = this.dialog.open(ConfirmationmodalComponent, dialogConfig);
    dialogRef.componentInstance.title = 'Confirm';
    dialogRef.componentInstance.mode = 'Add';
    dialogRef.componentInstance.message = 'Are you sure you want to update the status?';

    dialogRef.afterClosed().subscribe((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.restService.updateAdminStatus(adminInfo.userId, false).subscribe({
          next: (response: string) => {
            this.notificationService.showNotification('Status updated sucessfully');
            if (this.selectedTab === 0)
              this.memberService.emitRefreshAdminInsurer();
            else if (this.selectedTab === 1) {
              this.memberService.emitRefreshAdminProvider();
            }
            else {
              this.memberService.emitRefreshAdminDistributor();
            }
          },
          error: (error) => {
            const message = error?.error?.message || 'An error occurred during status update.';
            this.notificationService.showNotification(message, 'error');
          }
        });
      }
    })

  }
  openAdminDistributorProfile(userId: any) {
    console.log(userId)
    this.router.navigateByUrl(`dashboard/adminprofile/${userId}`)
  }
  openAdminProfile(userId: any) {
    const userID = userId;
    console.log(userID);
    this.router.navigateByUrl(`dashboard/adminprofile/${userID}`)


  }
  openAdminInsurerForm(row: any) {
    const rows = row;
    console.log(row);
    const adminInsurerDialogConfig = new MatDialogConfig();
    adminInsurerDialogConfig.data = row;
    adminInsurerDialogConfig.width = '750px';
    adminInsurerDialogConfig.height = '600px'
    const adminInsurerReference = this.dialog.open(CommonAdminComponentComponent, adminInsurerDialogConfig)

  }


  changeViewMode(mode: 'list' | 'grid') {
    this.viewMode = mode;
  }
  viewMode: 'grid' | 'list' = 'grid';

  openAdminDistributor() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '750px';
    dialogConfig.height = '600px';
        this.selectedTab=2;
        this.getAdminDistributor()

    this.dialog.open(AddAdminDistributorComponent, dialogConfig);

  }
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const tab = +params['tab'] || 0;
      this.selectedTab = tab;
    });

    this.memberService.refreshAdminInsurer$.subscribe(() => {
      // if(this.selectedTab=0){
      this.getAdminInsurers();
    this.selectedTab=0}
    // }
  );

    this.memberService.refreshAdminProvider$.subscribe(() => {
      // if(this.selectedTab=1){
      this.getAdminProviders();
    this.selectedTab=1}
    // }
  );
    this.memberService.refreshAdminDistributor$.subscribe(() => {
      // if(this.selectedTab=2){
      this.getAdminDistributor();
    this.selectedTab=2}
    // }
  )

    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });

    // if(this.selectedTab == 0)
    this.getAdminInsurers();
    // if(this.selectedTab == 1)
    this.getAdminProviders();
    // if(this.selectedTab == 2)
    this.getAdminDistributor();

    console.log(this.viewMode)
    this.getAdminDistributor();
   
  }


  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updateVisibleItems();
    }
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateVisibleItems();
    }
  }
  getAdminDistributor() {
    this.adminDistributorList = [];
    this.isDataLoading = true;
    this.restService.getAllAdminDistributors().subscribe({
      next: (values: any[]) => {
        if (values.length > 0) {
          const sorted = values
            .filter(agent => agent.createdon)
            .sort((a, b) => new Date(b.createdon).getTime() - new Date(a.createdon).getTime());

          this.adminDistributorListTemp = sorted;
          this.tabs[2].count = this.adminDistributorListTemp.length;
          this.isDataLoading = false;

          // Apply current filter and update pagination
          this.applyFilter(this.selectedFilter);
        } else {
          this.isDataLoading = false;
          this.adminDistributorListTemp = [];
          this.tabs[2].count = 0;
          this.calculateTotalPages([]);
          this.updateVisibleItems();
        }
      },
      error: (err) => {
        this.isDataLoading = false;
        this.adminDistributorListTemp = [];
        this.tabs[2].count = 0;
        this.calculateTotalPages([]);
        this.updateVisibleItems();
      }
    })
  }
  getAdminInsurers() {
    this.adminInsurerList = [];
    this.isDataLoading = true;

    this.restService.getAllAdminInsurers().subscribe({
      next: (response: any[]) => {
        
        if (response.length > 0) {
          const sorted = response
            .filter(agent => agent.createdon)
            .sort((a, b) => new Date(b.createdon).getTime() - new Date(a.createdon).getTime()
             
            );

          this.adminInsurerListTemp = sorted;
          this.tabs[0].count = this.adminInsurerListTemp.length;
          this.isDataLoading = false;

          // Apply current filter and update pagination
          this.applyFilter(this.selectedFilter);
        } else {
          this.isDataLoading = false;
          this.adminInsurerListTemp = [];
          this.tabs[0].count = 0;
          this.calculateTotalPages([]);
          this.updateVisibleItems();
        }
      },
      error: () => {
        this.isDataLoading = false;
        this.adminInsurerListTemp = [];
        this.tabs[0].count = 0;
        this.calculateTotalPages([]);
        this.updateVisibleItems();
      }
    });
  }
  getAdminProviders() {
    this.adminProviderList = [];
    this.isDataLoading = true;

    this.restService.getAllAdminProviders().subscribe({
      next: (response: any[]) => {
        if (response.length > 0) {
          const sorted = response
            .filter(agent => agent.createdon)
            .sort((a, b) => new Date(b.createdon).getTime() - new Date(a.createdon).getTime());

          this.adminProviderListTemp = sorted;
          this.tabs[1].count = this.adminProviderListTemp.length;
          this.isDataLoading = false;

          // Apply current filter and update pagination
          this.applyFilter(this.selectedFilter);
        } else {
          this.isDataLoading = false;
          this.adminProviderListTemp = [];
          this.tabs[1].count = 0;
          this.calculateTotalPages([]);
          this.updateVisibleItems();
        }
      },
      error: () => {
        this.isDataLoading = false;
        this.adminProviderListTemp = [];
        this.tabs[1].count = 0;
        this.calculateTotalPages([]);
        this.updateVisibleItems();
      }
    });
  }

  searchQuery: string = '';
  isRotating: boolean = false;

  adminProviderList: any[] = [];
  adminProviderListTemp: any[] = [];
  adminProviderColumns: string[] = ['Name', 'Activation Term', 'Phone', 'Email', 'Address', 'Status', 'Actions'];
  adminInsurerColumns: string[] = ['Name', 'Activation Term',  'Phone', 'Email', 'Address','Status', 'Actions'];
  adminDistributerColumns: string[] = ['Name', 'Activation Term', 'Phone', 'Email', 'Address', 'Status', 'Actions']


  selectedTab = 0;
  tabs = [
    { label: 'Insurer Admins', count: 0 },
    { label: 'Provider Admins', count: 0 },
    { label: 'Distributor Admins', count: 0 }
  ];

  toggleSearch() {
    this.searchExpanded = !this.searchExpanded;
    if (!this.searchExpanded) {
      this.searchQuery = '';
      this.onSearch(); // reset search on close
    }
  }
  onSearch() {
    // Reset to page 1 when searching
    this.currentPage = 1;

    if (this.selectedTab == 0) {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) {
        // Apply current filter to temp list and then paginate
        const filteredList = this.getFilteredList(this.adminInsurerListTemp, this.selectedFilter);
        this.calculateTotalPages(filteredList);
        this.updateVisibleItems();
        return;
      }
      const filteredList = this.getFilteredList(this.adminInsurerListTemp, this.selectedFilter);
      const searchResults = filteredList.filter(row =>
        Object.values(row).some(val =>
          val && val.toString().toLowerCase().includes(query)
        )
      );
      this.calculateTotalPages(searchResults);
      this.updateVisibleItems();
    }
    else if (this.selectedTab === 1) {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) {
        // Apply current filter to temp list and then paginate
        const filteredList = this.getFilteredList(this.adminProviderListTemp, this.selectedFilter);
        this.calculateTotalPages(filteredList);
        this.updateVisibleItems();
        return;
      }
      const filteredList = this.getFilteredList(this.adminProviderListTemp, this.selectedFilter);
      const searchResults = filteredList.filter(row =>
        Object.values(row).some(val =>
          val && val.toString().toLowerCase().includes(query)
        )
      );
      this.calculateTotalPages(searchResults);
      this.updateVisibleItems();
    }
    else if (this.selectedTab === 2) {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) {
        // Apply current filter to temp list and then paginate
        const filteredList = this.getFilteredList(this.adminDistributorListTemp, this.selectedFilter);
        this.calculateTotalPages(filteredList);
        this.updateVisibleItems();
        return;
      }
      const filteredList = this.getFilteredList(this.adminDistributorListTemp, this.selectedFilter);
      const searchResults = filteredList.filter(row =>
        Object.values(row).some(val =>
          val && val.toString().toLowerCase().includes(query)
        )
      );
      this.calculateTotalPages(searchResults);
      this.updateVisibleItems();
    }
  }
  openAdminProvider() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '750px';
    dialogConfig.height = '600px'
    this.selectedTab=1
    this.getAdminProviders()
    this.dialog.open(CommonAdminComponentComponent, dialogConfig);
  }


  handleTabClick(index: number): void {
    this.selectedTab = index;
    this.currentPage = 1;
    this.searchQuery = ''; // Reset search when switching tabs
    this.onTabClick();
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateVisibleItems();
    }
  }



  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateVisibleItems();
    }
  }

  calculateTotalPages(list: any[]): void {
    this.totalPages = Math.ceil(list.length / this.itemsPerPage);
  }

  currentPage = 1;
  itemsPerPage = 6;
  totalPages = 1;

  selectedFilter: 'all' | 'active' | 'inactive' = 'all';
  applyFilter(filterType: 'all' | 'active' | 'inactive'): void {
    this.selectedFilter = filterType;
    // Reset to page 1 when filtering
    this.currentPage = 1;

    if (this.selectedTab === 0) {
      const filteredList = this.getFilteredList(this.adminInsurerListTemp, filterType);
      this.calculateTotalPages(filteredList);
      this.updateVisibleItems();
    } else if (this.selectedTab === 1) {
      const filteredList = this.getFilteredList(this.adminProviderListTemp, filterType);
      this.calculateTotalPages(filteredList);
      this.updateVisibleItems();
    } else if (this.selectedTab === 2) {
      const filteredList = this.getFilteredList(this.adminDistributorListTemp, filterType);
      this.calculateTotalPages(filteredList);
      this.updateVisibleItems();
    }
  }

  private getFilteredList(list: any[], type: 'all' | 'active' | 'inactive'): any[] {
    if (type === 'active') return list.filter(item => item.isactive);
    if (type === 'inactive') return list.filter(item => !item.isactive);
    return [...list]; // all
  }

  updateVisibleItems(): void {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;

    if (this.selectedTab === 0) {
      // Apply filter first
      let filteredList = this.getFilteredList(this.adminInsurerListTemp, this.selectedFilter);

      // Apply search if there's a search query
      if (this.searchQuery.trim()) {
        filteredList = filteredList.filter(row =>
          Object.values(row).some(val =>
            val && val.toString().toLowerCase().includes(this.searchQuery.trim().toLowerCase())
          )
        );
      }

      // Apply pagination
      this.adminInsurerList = filteredList.slice(start, end);
    } else if (this.selectedTab === 1) {
      // Apply filter first
      let filteredList = this.getFilteredList(this.adminProviderListTemp, this.selectedFilter);

      // Apply search if there's a search query
      if (this.searchQuery.trim()) {
        filteredList = filteredList.filter(row =>
          Object.values(row).some(val =>
            val && val.toString().toLowerCase().includes(this.searchQuery.trim().toLowerCase())
          )
        );
      }

      // Apply pagination
      this.adminProviderList = filteredList.slice(start, end);
    } else if (this.selectedTab === 2) {
      // Apply filter first
      let filteredList = this.getFilteredList(this.adminDistributorListTemp, this.selectedFilter);

      // Apply search if there's a search query
      if (this.searchQuery.trim()) {
        filteredList = filteredList.filter(row =>
          Object.values(row).some(val =>
            val && val.toString().toLowerCase().includes(this.searchQuery.trim().toLowerCase())
          )
        );
      }

      // Apply pagination
      this.adminDistributorList = filteredList.slice(start, end);
    }
  }

  onTabClick(): void {
    if (this.selectedTab === 0) {
      this.getAdminInsurers();
    }
    if (this.selectedTab === 1) {
      this.getAdminProviders();
    }
    else {
      this.getAdminDistributor();
    }
    // Don't call applyFilter here as it will be called in the data loading methods
  }

  searchExpanded = false;
  isDataLoading: boolean = false;

  isSidebarExpanded = false;
  role = this.memberService.getLoginUserRole();
  enumRole = Roles;
  currentState: AgentFilterState = 'all';

  onRefresh() {
    this.isRotating = true;

    if (this.selectedTab === 0) {
      this.getAdminInsurers();
    } else if (this.selectedTab === 1) {
      this.getAdminProviders();
    } else if (this.selectedTab === 2) {
      this.getAdminDistributor();
    }

    // Stop animation after 1s (match CSS animation duration)
    setTimeout(() => {
      this.isRotating = false;
    }, 500);
  }

}
